export const PRICE_POPUP_PROJECTS = ["EAY", "EBY", "EDY"];